export function removeDuplicates(array: any[], key: any) {
  return array.reduce((accumulator, current) => {
    if (!accumulator.some((item: any) => item[key] === current[key])) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);
}
